<template>
  <div :style="loginStyle" class="auth-wrapper auth-v2">
    <b-row class="auth-inner m-0 justify-content-center">
      <b-col lg="11" class="pt-5 pl-3">
        <InitialHeader :onlyLogo="true" />
      </b-col>
      <b-col
          sm="12"
          md="12"
          lg="11"
          class="d-flex align-items-center mb-5"
      >
        <b-col
            sm="12"
            md="10"
            lg="4"
            class="mx-auto auth-bg p-2 rounded"
        >
          <div id="redefinir-senha" class="px-xl-3 pb-1 pt-3">
            <h2 class="mb-1 auth-title">
              Redefina sua nova senha
            </h2>

            <p class="text-muted mb-2">
              <feather-icon class="icons-color" icon="CheckCircleIcon" />
              Sua senha deve conter no mínimo 8 caracteres.
            </p>
          </div>

          <div id="nova-senha" class="px-xl-3 pt-1 pb-3">
            <b-alert
                v-if="errorMessage"
                show
                fade
                class="mb-2"
                variant="danger"
            >
              <div class="custom-alert">
                <span>{{ errorMessage }}</span>
              </div>
            </b-alert>

            <b-form class="auth-login-form mt-2" @submit.prevent="resetPassword">
              <b-form-group label="Nova Senha" label-for="nova-senha">
                <b-input-group class="input-group-merge">
                  <b-form-input
                      id="nova-senha"
                      v-model="form.novaSenha"
                      class="form-control-merge"
                      :type="passwordFieldType"
                      name="nova-senha"
                      placeholder="********"
                      @focus="errorMessage = ''"
                      @input="validatePassword"
                      required
                  />
                  <b-input-group-append is-text>
                    <feather-icon
                        class="cursor-pointer"
                        :icon="passwordToggleIcon"
                        @click="togglePasswordVisibility"
                    />
                  </b-input-group-append>
                </b-input-group>
                <small v-if="!passwordValid && form.novaSenha" class="text-danger">
                  A senha deve ter no mínimo 8 caracteres.
                </small>
              </b-form-group>

              <b-form-group label="Confirmar Nova Senha" label-for="confirmar-senha">
                <b-input-group class="input-group-merge">
                  <b-form-input
                      id="confirmar-senha"
                      v-model="form.confirmarSenha"
                      class="form-control-merge"
                      :type="confirmPasswordFieldType"
                      name="confirmar-senha"
                      placeholder="********"
                      @focus="errorMessage = ''"
                      required
                  />
                  <b-input-group-append is-text>
                    <feather-icon
                        class="cursor-pointer"
                        :icon="confirmPasswordToggleIcon"
                        @click="toggleConfirmPasswordVisibility"
                    />
                  </b-input-group-append>
                </b-input-group>
                <small v-if="form.confirmarSenha && form.novaSenha !== form.confirmarSenha" class="text-danger">
                  As senhas não coincidem.
                </small>
              </b-form-group>

              <button
                  :disabled="loading"
                  type="submit"
                  class="btn button-form btn-block"
              >
                {{ loading ? 'Salvando...' : 'Salvar' }}
              </button>
            </b-form>

            <p class="text-center mt-2">
              <b-link :to="{name:'public-login'}">
                <feather-icon icon="ChevronLeftIcon" size="16" />
                <span class="to-login">&nbsp;Volte ao Login</span>
              </b-link>
            </p>
          </div>
        </b-col>
      </b-col>
      <FooterInitial />
    </b-row>
  </div>
</template>

<script>
import {
  BAlert,
  BCol,
  BForm,
  BFormGroup,
  BFormInput,
  BInputGroup,
  BInputGroupAppend,
  BLink,
  BRow,
} from 'bootstrap-vue'
import FooterInitial from '@/views/components/custom/footer/FooterInitial.vue'
import InitialHeader from '@/views/components/custom/page-header/InitialHeader.vue'

export default {
  name: 'PublicResetPassword',
  components: {
    BAlert,
    BCol,
    BForm,
    BFormGroup,
    BFormInput,
    BInputGroup,
    BInputGroupAppend,
    BLink,
    BRow,
    FooterInitial,
    InitialHeader,
  },
  props: ['token'],
  data() {
    return {
      form: {
        novaSenha: '',
        confirmarSenha: '',
        token: this.token,
      },
      loading: false,
      errorMessage: '',
      passwordFieldType: 'password',
      confirmPasswordFieldType: 'password',
      passwordValid: true,
      loginStyle: {
        'background-image': `url(${require('@/assets/custom-images/bg/bg-login.png')})`,
        'background-repeat': 'no-repeat',
        'background-position': 'center center',
        'background-size': 'cover',
      },
    }
  },
  computed: {
    passwordToggleIcon() {
      return this.passwordFieldType === 'password' ? 'EyeIcon' : 'EyeOffIcon'
    },
    confirmPasswordToggleIcon() {
      return this.confirmPasswordFieldType === 'password' ? 'EyeIcon' : 'EyeOffIcon'
    },
  },
  methods: {
    togglePasswordVisibility() {
      this.passwordFieldType = this.passwordFieldType === 'password' ? 'text' : 'password'
    },
    toggleConfirmPasswordVisibility() {
      this.confirmPasswordFieldType = this.confirmPasswordFieldType === 'password' ? 'text' : 'password'
    },
    validatePassword() {
      const password = this.form.novaSenha
      this.passwordValid = !password || password.length >= 8
    },
    async resetPassword() {
      this.errorMessage = ''

      if (!this.form.novaSenha || !this.form.confirmarSenha) {
        this.errorMessage = 'Preencha todos os campos.'
        return
      }

      if (this.form.novaSenha.length < 8) {
        this.errorMessage = 'A senha deve ter no mínimo 8 caracteres.'
        return
      }

      if (this.form.novaSenha !== this.form.confirmarSenha) {
        this.errorMessage = 'As senhas não coincidem.'
        return
      }

      this.loading = true

      try {
        await this.$store.dispatch('publicAccess/resetPassword', {
          token: this.form.token,
          senha: this.form.novaSenha,
        })

        this.$swal({
          title: 'Senha alterada com sucesso!',
          text: 'Volte à página de login e acesse com sua nova senha.',
          icon: 'success',
          confirmButtonText: 'Ok',
        }).then(() => {
          this.$router.push({ name: 'public-login' })
        })
      } catch (error) {
        const message = error?.response?.data?.message
        this.errorMessage = message || 'Token inválido ou expirado.'
      } finally {
        this.loading = false
      }
    },
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/pages/page-auth.scss';
</style>
